import { profileTypeLabel } from "@commonqr/shared/config/cardProfileTypes";

interface ProfileTypeLabelProps {
  profileType: string;
}

export function ProfileTypeLabel({ profileType }: ProfileTypeLabelProps) {
  const label = profileTypeLabel(profileType);
  return (
    <span className="inline-flex items-center rounded-full bg-slate-100 text-slate-600 px-3 py-1 text-xs font-semibold uppercase tracking-wide">
      {label}
    </span>
  );
}
